/**
 * @constructor
 */
class BreadcrumbLangCheck {
  constructor() {
    this.init();
  }

  /**
   * パンクズのspanの中身を日本語か英語かを判断して、それぞれのspanに
   * lang="ja"、lang="en"を付ける
   * cssの:lang()の疑似クラスでfont-sizeを指定します
   */
  init() {
    this.breadcrumbLangCheck();
  }
  breadcrumbLangCheck() {
    // パンくずリストの各要素を取得してループ処理
    document.querySelectorAll('.l-breadcrumb__listItem span').forEach(span => {
      // span 要素のテキストを取得
      const text = span.textContent;
      // テキストから言語を検出
      const language = this.detectLanguage(text);
      // span 要素に lang 属性を設定
      span.setAttribute('lang', language);
    });
  }

  /**
   * テキストから言語を検出するメソッド
   * @param {string} text - テキスト
   * @returns {string} - 検出された言語 ('ja' または 'en')
   */
  detectLanguage(text) {
    // 日本語の正規表現パターン
    const japaneseRegex = /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}ー・「」、。]/u;
    // テキストに日本語の文字が含まれているかチェックし、言語を判定
    return japaneseRegex.test(text) ? 'ja' : 'en';
  }
}

export default BreadcrumbLangCheck;
